export const defaultBoddyHeight = 292;
export const defaultSettingHeight = 341;
export const defaultHeaderHeight = 126;
export const defaultFooterHeight = 50;
